export const TYPE_DOCUMENTS_LIST_REQUESTING = 'type-documents/TYPE_DOCUMENTS_LIST_REQUESTING';
export const TYPE_DOCUMENTS_LIST_SUCCESS = 'type-documents/TYPE_DOCUMENTS_LIST_SUCCESS';
export const TYPE_DOCUMENTS_LIST_FAILED = 'type-documents/TYPE_DOCUMENTS_LIST_FAILED';

export const DOCUMENTS_BY_TYPE_DEMANDS_REQUESTING = 'type-documents/DOCUMENTS_BY_TYPE_DEMANDS_REQUESTING';
export const DOCUMENTS_BY_TYPE_DEMANDS_SUCCESS = 'type-documents/DOCUMENTS_BY_TYPE_DEMANDS_SUCCESS';
export const DOCUMENTS_BY_TYPE_DEMANDS_FAILED = 'type-documents/DOCUMENTS_BY_TYPE_DEMANDS_FAILED';

